export const GET_SUB_CATEGORIES = 'GET_SUB_CATEGORIES'
export const ADD_NEW_SUB_CATEGORY = 'ADD_NEW_SUB_CATEGORY'
export const EDIT_SUB_CATEGORY = 'EDIT_SUB_CATEGORY'
export const DELETE_SUB_CATEGORY = 'DELETE_SUB_CATEGORY'